
import React, { useMemo } from 'react';

const StarryBackground: React.FC<{ children: React.ReactNode }> = React.memo(({ children }) => {
  const stars = useMemo(() => {
    return Array.from({ length: 100 }).map((_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      size: Math.random() * 2 + 0.5,
      delay: Math.random() * 10,
      duration: 3 + Math.random() * 7
    }));
  }, []);

  return (
    <div className="relative w-full h-full min-h-screen bg-[#020617] overflow-hidden flex flex-col items-center justify-center">
      {/* Background Gradient Layers */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#020617] via-[#0b0a24] to-[#1e1435]" />
      
      {/* Magic Nebulae */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[10%] left-[20%] w-[60%] h-[60%] bg-purple-600/10 rounded-full blur-[150px] animate-pulse" style={{ animationDuration: '12s' }} />
        <div className="absolute bottom-[10%] right-[10%] w-[50%] h-[50%] bg-blue-600/10 rounded-full blur-[150px] animate-pulse" style={{ animationDuration: '18s', animationDelay: '2s' }} />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-indigo-500/5 rounded-full blur-[200px]" />
      </div>

      {/* Twinkling Stars */}
      {stars.map(star => (
        <div
          key={star.id}
          className="absolute bg-white rounded-full opacity-0 animate-pulse"
          style={{
            left: star.left,
            top: star.top,
            width: `${star.size}px`,
            height: `${star.size}px`,
            animationDelay: `${star.delay}s`,
            animationDuration: `${star.duration}s`,
            boxShadow: star.size > 1.5 ? '0 0 10px rgba(255,255,255,0.8)' : 'none'
          }}
        />
      ))}

      {/* Floating Particles */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[20%] left-[10%] w-2 h-2 bg-yellow-400/20 rounded-full blur-sm animate-ping" style={{ animationDuration: '4s' }} />
        <div className="absolute bottom-[30%] right-[20%] w-1 h-1 bg-white/40 rounded-full blur-sm animate-ping" style={{ animationDuration: '6s', animationDelay: '1s' }} />
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center">
        {children}
      </div>
    </div>
  );
});

export default StarryBackground;
